// *****************************************************
// Swiper
// *****************************************************
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Thumbs, EffectFade, EffectCreative, Scrollbar } from "swiper";
// *****************************************************
// スワイパークラス
// *****************************************************
export class SwiperOperate {
  // ----------------------------------------------------
  // 機能：コンストラクタ
  // 引数：なし
  // 返値：なし
  //----------------------------------------------------
  constructor() {
    Swiper.use([Autoplay, Thumbs, Navigation, EffectFade]);
    // 通常スライダー
    const slider = document.querySelectorAll(".normalSlider");
    for (let i = 0; i < slider.length; i++) {
      const mySwiper = new Swiper(<HTMLElement>slider[i], {
        slidesPerView: 1.6,
        spaceBetween: 20,
        autoHeight: false, // スライド毎の高さに合わせる
        loop: true,
        centeredSlides: true,
        autoplay: {
          // 自動再生
          delay: 6000, // 間隔（ミリ秒）
          disableOnInteraction: true, // 操作されたら自動再生をストップさせる（true）設定（規定値true）
        },
        breakpoints: {
          600: {
            slidesPerView: 2.5,
          },
        },
      });
    }

    // 枠付きスライダー
    const containers = document.querySelectorAll(".swiper-outer");
    for (let i = 0; i < containers.length; i++) {
      let borderedSlider = containers[i].querySelector(".borderedSlider");
      let prev = containers[i].querySelector(".swiper-button-prev");
      let next = containers[i].querySelector(".swiper-button-next");
      let loop = false; // ループするかどうか
      if (borderedSlider instanceof HTMLElement && borderedSlider.dataset.loop === "true") {
        loop = true;
      }
      const autoplayOptions = loop
        ? {
            delay: 6000,
            disableOnInteraction: true,
          }
        : false;
      const mySwiper = new Swiper(<HTMLElement>borderedSlider, {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: false, // スライド毎の高さに合わせる
        loop: loop,
        autoplay: autoplayOptions,
        navigation: {
          nextEl: <HTMLElement>next,
          prevEl: <HTMLElement>prev,
        },
        breakpoints: {
          650: {
            slidesPerView: 2,
          },
          1100: {
            slidesPerView: 3,
          },
        },
      });
    }

    // サムネイル付きスライダー
    const picSliders = document.querySelectorAll(".pictureDataSlider");
    for (let i = 0; i < picSliders.length; i++) {
      let thumbSlider = picSliders[i].querySelector(".thumbSlider");
      let picturedSlider = picSliders[i].querySelector(".pictureSlider");
      let prev = picSliders[i].querySelector(".pictureSlider_prev");
      let next = picSliders[i].querySelector(".pictureSlider_next");
      const thumb = new Swiper(<HTMLElement>thumbSlider, {
        slidesPerView: 5, // サムネイルの表示数
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        threshold: 20,
      });
      const picture = new Swiper(<HTMLElement>picturedSlider, {
        fadeEffect: {
          crossFade: true,
        },
        effect: "fade",
        thumbs: {
          swiper: thumb,
        },
        navigation: {
          nextEl: <HTMLElement>next,
          prevEl: <HTMLElement>prev,
        },
        autoplay: {
          // 自動再生
          delay: 6000, // 間隔（ミリ秒）
          disableOnInteraction: true, // 操作されたら自動再生をストップさせる（true）設定（規定値true）
        },
      });
    }

    // ズーム（拡大）しながらフェードで切り替える
    const zoomSlider = new Swiper(".zoomSlider", {
      loop: true,
      slidesPerView: 1,
      fadeEffect: {
        crossFade: true,
      },
      effect: "fade",
      // 自動再生
      autoplay: {
        delay: 3000, // 次のスライドへ行く時間
        disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
      },
      speed: 1200, // フェード
    });
  }
}
